import StyledLinkButton from "features/shared/components/buttons/link-button/styles/StyledLinkButton.styled";
import { QuietButton } from "features/shared/components/buttons/QuietButton.styled";
import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import ChecklistResolutionStatus from "models/checklist/checklist-resolution-status";
import styled from "styled-components";

interface PaxDetailsProps {
  resolutionStatus: ChecklistResolutionStatus;
}
const PaxDetails = styled.div<PaxDetailsProps>`
  display: grid;
  margin: 0 16px;
  gap: 8px;

  ${QuietButton} {
    padding: 0;
    display: inline-flex;

    &:after {
      display: none;
    }
  }
  ${MicroHeader} {
    color: ${({ resolutionStatus, theme }) => {
      switch (resolutionStatus) {
        case ChecklistResolutionStatus.ReadyToFly:
          return theme.colors.confirmation;
        case ChecklistResolutionStatus.ActionRequired:
        default:
          return theme.colors.notResolvedChecklistStatus;
      }
    }};
  }

  ${StyledLinkButton} {
    display: inline-flex;
  }
`;

export default PaxDetails;
